import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { CreateUserInDto, ProjectOutDto, response, RoleDetails, RoleInDto, UpdateUserInDto, UpdateUserStatusInDto, UserDetails, UserInDto, UserOutDto } from "@app/share/type";
import { environment } from "environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http: HttpClient = inject(HttpClient);
  private ROLE_LIST_URL = environment.systemApi + "system/role/list";
  private OPERATE_ROLE_URL = environment.systemApi + "/system/role/";
  private USER_LIST_URL = environment.systemApi + "/system/user/list";
  private OPERATE_USER_URL = environment.systemApi + "/system/user/";
  private OPERATE_USER_STATUS_URL = environment.systemApi + "/system/user/status";
  private PROJECT_LIST_URL = environment.systemApi + "/system/project/list";
  private REQUEST_RESET_PSW_URL = environment.oldApi + "/auth/requestnewuserresetpsw";
  // private REQUEST_RESET_PSW_URL = environment.oldApi + "/auth/requestresetpsw";


  // 获取角色列表
  getRoleList(data: RoleInDto) {
      return this.http.get<response<Array<RoleDetails>>>(this.ROLE_LIST_URL, { params: { ...data } });
  }

  addRole(data: RoleInDto) {
    return this.http.post<null>(this.OPERATE_ROLE_URL, data);
  }

  editRole(data: RoleInDto) {
    return this.http.put<null>(this.OPERATE_ROLE_URL, data);
  }

  // 获取用户列表
  getUserList(data: UserInDto) {
    return this.http.get<response<UserOutDto>>(this.USER_LIST_URL, { params: { ...data } });
  }

  // 新增用户
  addUser(data: CreateUserInDto) {
    return this.http.post<response<null>>(this.OPERATE_USER_URL, data);
  }

  // 编辑用户
  editUser(data: UpdateUserInDto) {
    return this.http.put<response<null>>(this.OPERATE_USER_URL, data);
  }

  // 更新用户状态
  updateUserStatus(data: UpdateUserStatusInDto) {
    return this.http.put<response<null>>(this.OPERATE_USER_STATUS_URL, data);
  }

  // 获取项目列表
  getProjectList() {
    return this.http.get<response<Array<ProjectOutDto>>>(this.PROJECT_LIST_URL);
  }

  deleteUser(userId: string) {
    return this.http.delete<response<null>>(this.OPERATE_USER_URL + userId);
  }

  sendResetPswEmail(email: string) {
    return this.http.put<any>(this.REQUEST_RESET_PSW_URL, { email });
  }
}